export { FroalaViewDirective } from './view.directive';
export { FroalaViewModule } from './view.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-froala-wysiwyg/view/index.js
// module id = ./node_modules/angular-froala-wysiwyg/view/index.js
// module chunks = vendor